import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=25141926&scoped=true&"
import script from "./supplier.vue?vue&type=script&lang=js&"
export * from "./supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25141926",
  null
  
)

export default component.exports